<template>
  <div class="modal-card" style="width: 560px; max-width: 100%">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ quyTac ? lang('Sửa theo dõi bản mới') : lang('Thêm theo dõi bản mới') }}</p>
    </header>

    <section class="modal-card-body">
      <ChoXuLy :dang="dangTai" :uoc-tinh="25" :nhan="lang('Đang nhận diện tệp và tra cứu nguồn bản mới...')" />
      <ChoXuLy :dang="dangLuu && !quyTac" :uoc-tinh="12" :nhan="lang('Đang kiểm tra nguồn và lưu theo dõi...')" />

      <p class="td-ten">{{ tenTep }}</p>
      <p class="td-duong">{{ duongHienThi }}</p>

      <div v-if="loi" class="notification is-danger is-light">{{ loi }}</div>

      <div v-if="!quyTac && meta" class="td-nhandien">
        <div><b>{{ lang('Đã nhận diện') }}: {{ meta.ung_dung }} {{ meta.phien_ban }} ({{ meta.may }})</b></div>
        <div class="td-phu">{{ lang('Nhà phát hành') }}: {{ meta.nha_phat_hanh || '-' }}</div>
      </div>

      <b-field v-if="!quyTac && meta" :label="lang('Nguồn kiểm tra bản mới')">
        <b-select v-model="chonGoi" expanded>
          <option v-for="g in meta.goi_y" :key="g.id" :value="g.id">{{ g.ten }} · {{ tenNguon(g.id) }} ({{ g.id }})</option>
          <option value="">{{ lang('Nhập mã gói khác...') }}</option>
        </b-select>
      </b-field>
      <b-field v-if="!quyTac && meta && chonGoi === ''">
        <b-input v-model="maTuNhap" placeholder="7zip.7zip · scoop:7zip · github:chu/kho · url:https://…/Setup.exe" />
      </b-field>
      <p v-if="!quyTac && meta && meta.goi_y.length && !meta.ma_goi_tin_cay" class="help td-canh-bao">
        {{ lang('Chưa chắc chắn gợi ý nào đúng. Hãy chọn đúng phần mềm trong danh sách hoặc nhập mã gói, đừng bỏ qua bước này nếu để tự động tải.') }}
      </p>
      <p v-if="!quyTac && meta && !meta.goi_y.length" class="help">
        {{ lang('Chưa tìm được gợi ý. Nhập mã gói: winget (7zip.7zip), Scoop (scoop:7zip), kho GitHub (github:chu/kho) hoặc link tải cố định của hãng (url:https://…/Setup.exe)') }}
      </p>

      <b-field :label="lang('Khi có bản mới')" class="td-cachtai">
        <b-radio v-model="cheDo" native-value="tay">{{ lang('Chỉ thông báo, tôi tự bấm tải') }}</b-radio>
        <b-radio v-model="cheDo" native-value="tu_dong">{{ lang('Tự động tải khi có bản mới') }}</b-radio>
      </b-field>
      <p v-if="cheDo === 'tu_dong'" class="help">{{ lang('Hệ thống kiểm tra bản mới theo lịch mỗi ngày (khoảng 02:30), thấy có bản mới là tự tải và thay, duy trì về sau.') }}</p>

      <b-field v-if="!quyTac" class="td-taingay">
        <b-checkbox v-model="taiNgay">{{ lang('Tải ngay khi bấm Lưu') }}</b-checkbox>
      </b-field>
      <p v-if="!quyTac && taiNgay" class="help">{{ lang('Nếu đã có bản mới, hệ thống tải và thay ngay sau khi lưu (một lần). Việc có tự tải về sau hay không do mục "Khi có bản mới" ở trên quyết định.') }}</p>

      <b-checkbox v-model="giuCu">{{ lang('Giữ bản cũ') }}</b-checkbox>
      <p class="help" :class="{ 'td-canh-bao': !giuCu }">{{ ghiChu }}</p>
      <p v-if="meta && meta.vi_du_ten" class="help">{{ lang('Tên file bản mới') }}: <code>{{ meta.vi_du_ten }}</code></p>
    </section>

    <footer class="modal-card-foot">
      <button class="button" @click="$parent.close()">{{ lang('Cancel') }}</button>
      <button class="button is-primary" :class="{ 'is-loading': dangLuu }" :disabled="dangTai || dangLuu" @click="luu">{{ lang('Save') }}</button>
    </footer>
  </div>
</template>

<script>
import api from '../../api/api'
import ChoXuLy from './ChoXuLy'

export default {
  name: 'TheoDoiDialog',
  components: { ChoXuLy },
  props: {
    duongDan: { type: String, default: '' },
    quyTac: { type: Object, default: null },
  },
  data() {
    return {
      dangTai: false,
      dangLuu: false,
      taiNgay: false,
      meta: null,
      chonGoi: '',
      maTuNhap: '',
      cheDo: 'tay',
      giuCu: true,
      loi: '',
    }
  },
  computed: {
    duongHienThi() {
      return this.quyTac ? this.quyTac.duong_dan : this.duongDan
    },
    tenTep() {
      return this.duongHienThi.split('/').pop()
    },
    ghiChu() {
      return this.giuCu
        ? this.lang('Bản cũ được giữ nguyên bên cạnh bản mới.')
        : this.lang('Sau khi bản mới tải xong và kiểm tra hợp lệ, bản cũ sẽ được chuyển vào thùng rác (giữ 7 ngày, khôi phục được).')
    },
  },
  mounted() {
    if (this.quyTac) {
      this.cheDo = this.quyTac.che_do
      this.giuCu = !!this.quyTac.giu_cu
      return
    }
    this.dangTai = true
    api.capNhatNhanDien({ path: this.duongDan })
      .then(meta => {
        this.meta = meta
        this.chonGoi = meta.ma_goi_tin_cay || ''
        this.dangTai = false
      })
      .catch(error => {
        this.loi = this.noiDungLoi(error)
        this.dangTai = false
      })
  },
  methods: {
    tenNguon(id) {
      return /^scoop:/i.test(id) ? 'Scoop' : /^github:/i.test(id) ? 'GitHub' : /^url:/i.test(id) ? 'Link tải' : 'winget'
    },
    noiDungLoi(error) {
      const d = error && error.response && error.response.data && error.response.data.data
      return typeof d === 'string' ? d : this.lang('Unknown error')
    },
    luu() {
      this.loi = ''
      let lenh
      if (this.quyTac) {
        lenh = api.capNhatSua({ id: this.quyTac.id, che_do: this.cheDo, giu_cu: this.giuCu })
      } else {
        const ma = (this.chonGoi || this.maTuNhap).trim()
        if (!ma) {
          this.loi = this.lang('Chọn một nguồn gợi ý hoặc nhập mã gói (winget, scoop:..., github:..., url:...)')
          return
        }
        lenh = api.capNhatThem({ path: this.duongDan, ma_goi: ma, che_do: this.cheDo, giu_cu: this.giuCu, tai_ngay: this.taiNgay })
      }
      this.dangLuu = true
      lenh
        .then(ret => {
          this.dangLuu = false
          if (this.taiNgay) {
            this.$toast.open({
              message: ret && ret.dang_tai_ngay
                ? this.lang('Đã bắt đầu tải') + ' ' + ret.ung_dung + ' ' + ret.moi_nhat + ', ' + this.lang('xem tiến độ ở trang Tìm bản mới')
                : this.lang('Đã lưu. Đang là bản mới nhất nên chưa có gì để tải.'),
              type: 'is-success',
            })
          }
          this.$emit('saved', ret)
          this.$parent.close()
        })
        .catch(error => {
          this.dangLuu = false
          this.loi = this.noiDungLoi(error)
        })
    },
  },
}
</script>

<style scoped>
.td-ten { font-weight: 600; word-break: break-all; }
.td-duong { font-size: 0.8rem; color: #7d8a9a; margin-bottom: 0.9rem; word-break: break-all; }
.td-nhandien { background: rgba(127, 140, 160, 0.12); border-radius: 6px; padding: 0.6rem 0.8rem; margin-bottom: 0.9rem; }
.td-phu { font-size: 0.85rem; opacity: 0.8; }
.td-cachtai { margin-top: 0.9rem; }
.td-taingay { margin-bottom: 0.2rem; }
.td-canh-bao { color: #b45309; }
</style>
